import React, { useState, useEffect } from 'react';
import { View, Text, Image } from 'react-native';
import { Checkbox } from 'react-native-paper';

import HeaderDefault from '../../components/HeaderDefault';
import Button from '../../components/Button';
import ScreenLoader from '../../components/ScreenLoader';
import AsyncStorage from '@react-native-async-storage/async-storage';

import api from '../../services/api';

import styles from './styles';
import balanceService from '../../services/balanceService';
import { TouchableOpacity } from 'react-native-gesture-handler';
import { LinearGradient } from 'expo-linear-gradient';
import feeService from '../../services/feeService';
import { formatCoin, formatGPXBalance, maxDecimals } from '../../utils/formatNumber';

/*
 * ROUTE PARAMS -> qtd (float), token (actives.activeId), viewType(buy|sell), market (optional:true|false,default:false)
 */

const ConfirmPurchaseOrSell = (props) => {

    const [uri, setUri] = useState('../../../assets/imgs/gpx.png');
    const [nameToken, setNameToken] = useState('GPX');
    const [valueToken, setValueToken] = useState(1);

    const [qtd, setQtd] = useState(1);
    const [viewType, setViewType] = useState('buy');
    const [market, setMarket] = useState(false);
    const [customTokenValue, setCustomTokenValue] = useState(0)

    const [activeIdTokenId, setActiveIdTokenId] = useState();
    const [activeIdTokenObj, setActiveIdTokenObj] = useState();
    const [balance, setBalance] = useState(0); // Buy -> GPX/BRL Balance || Sell -> Active/Token Balance
    const [authToken, setAuthToken] = useState();
    const [fee, setFee] = useState({
        fee: 0.1,
        type: 'fixed'
    });
    const [taxes, setTaxes] = useState(0.1);
    const [loading1, setLoading1] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [loading3, setLoading3] = useState(false);

    //TODO: Carregar taxas.



    useEffect(() => {
        loadTokenAndRequest();
    }, [viewType]);

    useEffect(() => {
        if (props.route.params.qtd) // amount to sell or buy
            setQtd(props.route.params.qtd);
        else
            setQtd(1);
        if (props.route.params.token) // token/active to sell or buy
            setActiveIdTokenId(props.route.params.token);
        if (props.route.params.viewType) // sell or buy
            setViewType(props.route.params.viewType);
        if (props.route.params.market) // is market (exchange) order, or marketplace checkout
            setMarket(props.route.params.market);
        if (props.route.params.customTokenValue) {
            setCustomTokenValue(props.route.params.customTokenValue)
            //  console.log(props.route.params.customTokenValue)
        }

    }, []);

    useEffect(() => {
        getDataCoin();
    }, [activeIdTokenId]);

    useEffect(() => {
        if (authToken) {
            loadBalance();
            loadFees();
        }
    }, [authToken]);

    const loadTokenAndRequest = async () => {
        const authTokenStorage = await AsyncStorage.getItem('JWT_TOKEN');
        setAuthToken(authTokenStorage);
    }

    const loadBalance = () => {
        if (authToken) {
            if (viewType === 'buy') {
                setLoading1(true)
                balanceService.getBalanceOfGpx(authToken).then((response) => {
                    if (response?.data?.balance?.length > 0) {
                        setBalance(response?.data?.balance[0].saldo);
                    }
                    setLoading1(false)
                }).catch((error) => {
                    setLoading1(false)
                });
            } else if (viewType === 'sell' && activeIdTokenId) {
                setLoading1(true)
                balanceService.getBalanceOfToken(authToken, activeIdTokenId).then((response) => {
                    setBalance(response?.data?.saldo);
                    setLoading1(false)
                }).catch((error) => {
                    setLoading1(false)
                });
            }
        }
    }

    const getDataCoin = async () => {
        const token = await AsyncStorage.getItem('JWT_TOKEN');
        setLoading3(true)
        api.get(`/actives/${activeIdTokenId}`, { headers: { 'Authorization': `Basic ${token}` } })
            .then((res) => {
                if (res.data.actives.length > 0) {
                    setActiveIdTokenObj(res.data.actives[0]);
                    setNameToken(res.data.actives[0].name_token)
                    setUri(`https://filesgpx.s3.us-east-2.amazonaws.com/${res.data.actives[0].path}`)
                    customTokenValue > 0 ? setValueToken(customTokenValue) : setValueToken(res.data.actives[0].single_value); //TODO: Implementar valores fixos e flutuantes -> BUG

                    // res.data.actives[0].type_value == "Valor Fixo" ?
                    //     setValueToken(res.data.actives[0].single_value)
                    // :   setValueToken(res.data.actives[0].total_value_token)
                }
                setLoading3(false)
            })
            .catch((error) => {
                setLoading3(false)
                console.log(error);
            });
    }
    const loadFees = () => {
        if (authToken) {
            setLoading2(true)
            if (viewType === 'buy') {
                if (market) {
                    feeService.getExchangeBuyFeeByActiveId(authToken, activeIdTokenId).then((response) => {
                        if (response.status === 200) {
                            setFee(response.data);
                        } else {
                            console.log('Unable to load fee.')
                        }
                        setLoading2(false)
                    }).catch((error) => {
                        setLoading2(false)
                        console.log(error)
                    });
                } else {
                    feeService.getMarketplaceBuyFeeByActiveId(authToken, activeIdTokenId).then((response) => {
                        if (response.status === 200) {
                            setFee(response.data);
                        } else {
                            console.log('unable to load fee')
                        }
                        setLoading2(false)
                    }).catch((error) => {
                        setLoading2(false)
                        console.log(error)
                    });
                }
            } else {
                feeService.getExchangeSellFeeByActiveId(authToken, activeIdTokenId).then((response) => {
                    if (response.status === 200) {
                        setFee(response.data);
                    } else {
                        console.log('unable to load fee')
                    }
                    setLoading2(false)
                }).catch((error) => {
                    setLoading2(false)
                    console.log(error)
                });
            }
        }
    }

    const getCurrentFee = () => {
        //compra
        //criptoativo
        //Saldo em GPX para cobrir a compra
        //Taxa é descontada em criptomoeda do valor a receber após compra em tokens
        //Valor a receber é compra - taxa
        //não criptoativo
        //Saldo em GPX para cobrir a compra
        //Saldo em GPX para cobrir a taxa
        //venda
        //criptoativo
        //saldo só em tokens
        //taxa % ou fixa descontada do valor a receber em GPX
        // volume mínimo de compra é igual a taxa + alguma coisa
        //não criptoativo
        //necessário saldo em tokens
        //taxa % ou fixa descontada do valor a receber em GPX
        if (activeIdTokenObj?.cryptoactive && fee.type) {
            // console.log(fee)
            if (viewType === 'buy') {
                return formatCoin(fee.type === 'fixed' ? fee.fee : ((parseFloat(fee.fee) * parseFloat(qtd))), activeIdTokenObj.feezeroMk); // descontado no recebimento
            } else {
                return parseFloat(fee.type === 'fixed' ? (parseFloat(fee.fee) * parseFloat(valueToken)) : (parseFloat(fee.fee) * parseFloat(valueToken) * parseFloat(qtd))); // descontado no recebimento
            }
        } else if (fee.type) {
            return parseFloat(fee.type === 'fixed' ? fee.fee : ((parseFloat(fee.fee) * parseFloat(qtd) * parseFloat(valueToken)))); // descontado no recebimento
        }
    }

    const getCurrentFeeLabel = () => {
        let feeTmp = getCurrentFee();
        if (fee.currency == 'active' && activeIdTokenObj) {
            if(viewType === 'buy')
                return maxDecimals(feeTmp, 8) + ' ' + activeIdTokenObj.name_token;
            else
                return formatGPXBalance(feeTmp, 8) + ' ' + 'GPX/BRL';

        } else {
            return formatGPXBalance(feeTmp) + ' GPX/BRL';
        }
    }

    const minGpxBalance = () => {
        if (viewType == 'buy') {
            if (activeIdTokenObj?.cryptoactive && fee.type) {
                return qtd * valueToken;
            } else if (fee.type) {
                return ((qtd * valueToken) + getCurrentFee());
            }
        } else {
            if (activeIdTokenObj?.cryptoactive && fee.type) {
                return 0;
            } else if (fee.type) {
                return 0;
            }
        }
    }

    const minTokenBalance = () => {
        if (viewType == 'buy') {
            return 0;
        } else {
            return qtd;
        }
    }

    return (
        <>
            <ScreenLoader loading={loading1 || loading2 || loading3} />
            <HeaderDefault title={viewType === 'buy' ? 'Confirmar compra' : 'Confirmar venda'} />
            <View style={styles.header}>
                <Text style={styles.title}>Você confirma a {viewType === 'buy' ? 'compra' : 'venda'} abaixo?</Text>

                <View style={styles.contentImgsCoins}>
                    <Image source={{ uri: uri }} style={styles.imgCoins} />
                    <Image source={require('../../../assets/imgs/gpx.png')} style={styles.imgCoins} />
                </View>
                <View style={styles.contentPrice}>
                    <View>
                        <Text style={styles.textPriceLeft}>{viewType === 'buy' ? 'Compra' : 'Venda'}</Text>
                        <Text style={styles.price}>{qtd} {nameToken}</Text>
                    </View>
                    <View>
                        <Text style={styles.textPriceRight}>Valor</Text>
                        <Text style={styles.price}>{formatGPXBalance((qtd * valueToken))} GPX</Text>
                        <Text style={styles.priceSecondary}>{formatGPXBalance((qtd * valueToken))} BRL</Text>
                    </View>
                </View>
            </View>
            <View style={styles.container}>
                <View style={styles.confirmDataRow}>
                    <Text style={styles.confirmDataRowColTitle}>Saldo</Text>
                    <Text style={styles.confirmDataRowColText}>{viewType === 'buy' ? formatGPXBalance(balance) : balance} {activeIdTokenObj?.name_token && (viewType === 'buy' ? 'GPX/BRL' : activeIdTokenObj.name_token)}</Text>
                </View>
                {
                    activeIdTokenObj?.cryptoactive && viewType === 'sell' &&
                    <View style={styles.confirmDataRow}>
                        <Text style={styles.confirmDataRowColTitle}>Saldo após transação</Text>
                        <Text style={styles.confirmDataRowColText}>{
                        activeIdTokenObj?.cryptoactive ?
                                (maxDecimals(parseFloat(balance - qtd), 8) + ' ' + activeIdTokenObj?.name_token)
                            :
                            (
                                formatGPXBalance(parseFloat(balance - qtd)) + ' ' + activeIdTokenObj?.name_token
                        )}</Text>
                    </View>
                }
                <View style={styles.confirmDataRow}>
                    <Text style={styles.confirmDataRowColTitle}>Valor da transação</Text>
                    <Text style={styles.confirmDataRowColText}>{formatGPXBalance(parseFloat(qtd * valueToken))} GPX/BRL{/*activeIdTokenObj?.name_token && (viewType === 'buy' ? 'GPX' : activeIdTokenObj.name_token)*/}</Text>
                </View>
                {
                    !activeIdTokenObj?.cryptoactive &&
                    <View style={styles.confirmDataRow}>
                        <Text style={styles.confirmDataRowColTitle}>Taxa</Text>
                        <Text style={styles.confirmDataRowColText}>{getCurrentFeeLabel()}</Text>
                    </View>
                }
                <View style={styles.confirmDataRow}>
                    <Text style={styles.confirmDataRowColTitle}>{viewType === 'buy' ? 'Total' : 'Total a receber'}</Text>
                    <Text style={styles.confirmDataRowColText}>{(
                        viewType === 'buy' ?
                            (
                                activeIdTokenObj?.cryptoactive ?
                                    formatGPXBalance(parseFloat((qtd * valueToken) + parseFloat(getCurrentFee())))
                                    :
                                    formatGPXBalance(parseFloat((qtd * valueToken) + parseFloat(getCurrentFee())))
                            )
                            :
                            formatGPXBalance(parseFloat((qtd * valueToken) - getCurrentFee()))
                    )} GPX/BRL</Text>
                </View>
                {
                    activeIdTokenObj?.cryptoactive &&
                    <View style={styles.confirmDataRow}>
                        <Text style={styles.confirmDataRowColTitle}>Taxa</Text>
                        <Text style={styles.confirmDataRowColText}>{getCurrentFeeLabel()}</Text>
                    </View>
                }
                {
                    activeIdTokenObj?.cryptoactive && viewType === 'buy' &&
                    <View style={styles.confirmDataRow}>
                        <Text style={styles.confirmDataRowColTitle}>Total a receber</Text>
                        <Text style={styles.confirmDataRowColText}>{(
                            maxDecimals(parseFloat((qtd) - getCurrentFee()), 8) + ' ' + activeIdTokenObj?.name_token
                        )}</Text>
                    </View>
                }
                {
                    !activeIdTokenObj?.cryptoactive && viewType === 'buy' &&
                    <View style={{ ...styles.confirmDataRow, marginBottom: 15, marginTop: 15 }}>
                        <Text style={styles.confirmDataRowColTitle}>Saldo após transação</Text>
                        <Text style={styles.confirmDataRowColText}>{(
                            formatGPXBalance(parseFloat((balance - (parseFloat((qtd * valueToken) + getCurrentFee()).toFixed(2))) + '')) + ' GPX/BRL'
                        )}</Text>
                    </View>
                }

                {/* <View style={styles.contentCheckbox}>
                    <Checkbox
                        status={checked ? 'checked' : 'indeterminate'}
                        onPress={() => {
                            setChecked(!checked);
                        }}
                    />
                    <Text>
                        Ao clicar aqui eu concordo com os
                        <Text style={{ textDecorationLine: 'underline' }}> Termos de Uso</Text>,
                        <Text style={{ textDecorationLine: 'underline' }}> Política de Privacidade</Text>,
                        <Text style={{ textDecorationLine: 'underline' }}> Condições de Pagamento</Text>.
                    </Text>
                </View> */}
            </View>
            {
                (qtd * valueToken) < 11 ?
                <>
                    <View style={{ alignItems: 'center' }}>
                    <Text style={{ color: 'red', paddingTop: 5, paddingBottom: 5 }}>Mínimo de 11 GPX/BRL</Text>
                    </View>
                </>
                :
                (
                balance < (viewType === 'buy' ? minGpxBalance() : minTokenBalance()) ?
                    <Button route={"DepositMethod"} text={"SALDO INSUFICIENTE"} props={{}} />
                    :
                    <View style={styles.contentBtn}>
                        <TouchableOpacity onPress={() => props.navigation.navigate({
                            name: 'ConfirmPasswordPurchaseOrSell', params: {
                                purchase: (viewType === 'buy'),
                                qtd: qtd,
                                valueToken: valueToken,
                                token: activeIdTokenId,
                                market: market
                            }
                        })}>
                            <LinearGradient
                                start={{ x: -1, y: 0 }}
                                end={{ x: 1, y: 0 }}
                                colors={["#16195B", "#1FBFB5"]}
                                style={styles.btn}
                            >
                                <Text style={styles.textBtn}>CONFIRMAR</Text>
                            </LinearGradient>
                        </TouchableOpacity>
                    </View>
                )
            }

        </>
    );
}

export default ConfirmPurchaseOrSell;